import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { db } from "../../firebase/firebase";
import { getDocs, collection, query, where } from "firebase/firestore";
import { QueryKeys } from "config/query-keys";
import { EnumeratorInterface } from "api/enumerator/Profile/dto";

interface ApplicationStatus {
    id: string;
    jobId: string;
    applicant_info: EnumeratorInterface;
    status: string;
    appliedAt: string;
}

const getApplicationStatus = async (uid: string): Promise<ApplicationStatus[]> => {
    try {
        const applicationsCollectionRef = collection(db, "applications");

        const applicationsQuery = query(
            applicationsCollectionRef,
            where("applicant_info.uid", "==", uid)
        );

        const rawData = await getDocs(applicationsQuery);

        const applications: ApplicationStatus[] = rawData.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        })) as ApplicationStatus[];


        return applications;
    } catch (error) {
        console.error("Error fetching application statuses:", error);
        throw error;
    }
};

export const useGetApplicationStatus = (uid: string) => {
    const query = useQuery<ApplicationStatus[], AxiosError>({
        queryKey: [QueryKeys.CANDIDATE, uid],
        queryFn: () => getApplicationStatus(uid),
    });

    return query;
};
